// extracted by mini-css-extract-plugin
module.exports = {"diaolog":"dialog_diaolog__HALyX"};